import requestAction from '../../utils/requestAction'

export const fetchInvoices = (params: string) => 
  requestAction('INVOICE_LIST', params)(`invoices`, 'GET')
